// extracted by mini-css-extract-plugin
export default {"input":"InputNumber_input__dex6L"};